import React, { useEffect } from "react";
import "./Skills.css";
import SkillsBlock1 from "./SkillsBlock1";
import Certificates from "./Certificates";
import Preloader from "./Preloader";

const Skills = () => {
  const body = document.getElementsByTagName("body")[0];
  body.style.overflow = "hidden";
  useEffect(() => {
    if (document.getElementById("hidden_div") !== null)
      document.getElementById("hidden_div").style.display = "none";
    setTimeout(() => {
      const PreLoad = document.getElementById("skillPreload");
      if (PreLoad) {
        console.log("Not null preload")
        PreLoad.style.display = "none";
        body.style.overflow = "visible";
      }
      else
        console.log("Null preload")
    }, 2000);
  });
  // const achievement=[{data:""}]
  return (
    <>
      <Preloader id="skillPreload" />

      <div id="skillsOuter">
        <SkillsBlock1 />
        <Certificates />

        <div id="achievements">
          <div id="achievements_header">Achievements</div>
          <div id="achievements_Inner">
            <div id="achievement1">
              <div>I have solved more than 800 DSA questions on leetcode.</div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have done a Python Developer Internship at Infosys. It was a
                virtual internship.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have done a Frontend Developer Internship at IBM. It was a
                virtual internship.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have appointed as a Campus Ambassador of GeeksforGeeks for my
                college PSIT Kanpur for a year.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I am a MERN fullstack web developer. I have made so many
                fullstack projects.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have learnt Machine Learning concepts and applied them to make
                real world projects.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have learnt Machine Learning concepts and applied them to make
                real world projects.
              </div>
            </div>
            <hr />
            <div id="achievement1">
              <div>
                I have learnt Machine Learning concepts and applied them to make
                real world projects.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
